import { useContext } from "react";
import { HomeRepairAuthContext } from "../components/HomeRepairAuthProvider";

export const useHomeRepairAuth = () => useContext(HomeRepairAuthContext);
export default useHomeRepairAuth;
